export const ShipTypeEnums = {
  OTHER: { label: '其他', value: 999 },
  ZHAHUO: { label: '杂货船', value: 10 },
  SHANHUO: { label: '散货船', value: 20 },
  JIZHUANGXIANG: { label: '集装箱船', value: 30 },
  GUNZHUANG: { label: '滚装船', value: 40 },
  ZAIBO: { label: '载驳船', value: 50 },
  YOU: { label: '油船', value: 60 },
  YEHUAQI: { label: '液化气船', value: 70 },
  LENGCHANG: { label: '冷藏船', value: 80 },
  JIAYOU: { label: '加油船', value: 90 },
  JIAYOUBO: { label: '加油驳船', value: 100 },
  YINHANG: { label: '引航船', value: 110 },
  SHOUJIU: { label: '搜救船', value: 120 },
  TUOLUN: { label: '拖轮船', value: 130 },
  GANGKOUGONGYING: { label: '港口供应船', value: 140 },
  FANGWENRAN: { label: '载有防污染装置和设备的船舶', value: 150 },
  ZHIFA: { label: '执法艇', value: 160 },
  BEIYONG: { label: '备用-用于当地船舶的任务分配', value: 170 },
  YILIAO: { label: '医疗船', value: 180 },
  JUEYI18: { label: '18号决议船', value: 190 },
  PULAO: { label: '捕捞船', value: 200 },
  TUOYIN: { label: '拖引船', value: 210 },
  DATUOYIN: { label: '大托引船', value: 220 },
  SHUJUN: { label: '疏浚或水下作业船', value: 230 },
  QIANSHUI: { label: '潜水作业船', value: 240 },
  JUNSHI: { label: '军事行动船', value: 250 },
  FANCHUAN: { label: '帆船航行船', value: 260 },
  YULE: { label: '娱乐船', value: 270 },
  DIXIAO: { label: '地效应船', value: 280 },
  GAOSHU: { label: '高速船', value: 290 },
  KECHUAN: { label: '客船', value: 300 }
}
